import React from 'react';
import { Instagram, Linkedin, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';
// Custom TikTok icon since it's not available in lucide-react
const TikTokIcon = ({
  size = 20
}) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-9">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-10" />
  </svg>;
// Custom X (formerly Twitter) icon
const XIcon = ({
  size = 20
}) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-11">
    <path d="M6 4l12 16M18 4L6 20" data-id="element-12" />
  </svg>;
const SocialLink = ({
  href,
  icon: Icon,
  label
}: {
  href: string;
  icon: typeof Instagram | typeof TikTokIcon | typeof XIcon;
  label: string;
}) => <a href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/5 hover:bg-[#87CEEB]/20 text-white/80 hover:text-[#87CEEB] transition-all duration-200 transform hover:scale-110" aria-label={label} data-id="element-13">
    <Icon size={20} data-id="element-14" />
  </a>;
export const Footer = () => {
  const scrollToStory = () => {
    const element = document.getElementById('story');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-black text-white/80" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-17">
          {/* Navigation Links */}
          <div className="col-span-1" data-id="element-18">
            <h3 className="font-semibold text-white text-lg mb-4" data-id="element-19">
              Navigation
            </h3>
            <ul className="space-y-3" data-id="element-20">
              <li data-id="element-21">
                <Link to="/" onClick={scrollToStory} className="text-white/80 hover:text-[#87CEEB] transition-colors inline-block" data-id="element-22">
                  About
                </Link>
              </li>
              <li data-id="element-23">
                <Link to="/contact" className="text-white/80 hover:text-[#87CEEB] transition-colors inline-block" data-id="element-24">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          {/* Social Links */}
          <div className="col-span-1 md:col-span-3" data-id="element-25">
            <h3 className="font-semibold text-white text-lg mb-4" data-id="element-26">Connect</h3>
            <p className="mb-6 text-sm md:text-base" data-id="element-27">
              Contact Customer Support for questions on events, speaking
              engagements, or business inquiries.
            </p>
            <div className="flex gap-2" data-id="element-28">
              <SocialLink href="https://www.instagram.com/realelliotmartinez/" icon={Instagram} label="Instagram" data-id="element-29" />
              <SocialLink href="https://www.linkedin.com/in/elliot-martinez-4b93711b7/" icon={Linkedin} label="LinkedIn" data-id="element-30" />
              <SocialLink href="https://www.youtube.com/@EJMInspire/shorts" icon={Youtube} label="YouTube" data-id="element-31" />
              <SocialLink href="https://www.tiktok.com/@elliotjmartinez?lang=en" icon={TikTokIcon} label="TikTok" data-id="element-32" />
              <SocialLink href="https://x.com/Elliotjmartinez" icon={XIcon} label="X (Twitter)" data-id="element-33" />
            </div>
          </div>
        </div>
        {/* Footer Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10" data-id="element-34">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-35">
            <p className="text-sm order-2 md:order-1" data-id="element-36">
              © 2024 EJM Inspire. All rights reserved.
            </p>
            <div className="flex gap-6 order-1 md:order-2" data-id="element-37">
              <Link to="/privacy" className="text-sm text-white/80 hover:text-[#87CEEB] transition-colors" data-id="element-38">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-white/80 hover:text-[#87CEEB] transition-colors" data-id="element-39">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};